export default {
  currentIndex: 0,
  currentTrackId: null,
  tracklist: [],
  position: "first" // first, last, middle, one
};
